// extracted by mini-css-extract-plugin
export default {"tile":"tile_tile__CaQXu","content":"tile_content__XcFww"};